import './mini-cart'
import './single-product'
import './loop-products'
import './latest-products'
import './woo-filters'
// import './checkout'
import './checkout-coupon'
import './checkout-extras'
import './translations'
import './quicklook'
import './cross-sells'

// jQuery(document.body).on(
//     [
//         // Add to cart / cart
//         'adding_to_cart',
//         'added_to_cart',
//         'wc_cart_button_updated',
//         'removed_from_cart',
//         'wc_cart_emptied',
//         'wc_fragment_refresh',
//         'wc_fragments_refreshed',
//         'wc_fragments_loaded',
//         'cart_page_refreshed',
//         'updated_wc_div',

//         // Mini cart / fragments
//         'wc_fragments_loaded',
//         'wc_fragments_refreshed',

//         // Checkout lifecycle
//         'init_checkout',
//         'update_checkout',
//         'updated_checkout',
//         'checkout_error',
//         'reset_data',

//         // Cart totals / shipping
//         'updated_cart_totals',
//         'cart_totals_refreshed',
//         'updated_shipping_method',
//         'country_to_state_changed',

//         // Coupons
//         'applied_coupon',
//         'removed_coupon',
//         'applied_coupon_in_checkout',
//         'removed_coupon_in_checkout',

//         // Payments
//         'payment_method_selected',
//         'init_add_payment_method',

//         // Variations
//         'found_variation',
//         'reset_variations',
//         'hide_variation',
//         'show_variation',

//         // Subscriptions (WooCommerce Subscriptions)
//         'wcs_updated_subscription_totals',
//         'wcs_cart_totals_updated',
//         'wcs_switch_proration_updated',

//         // All Products for Subscriptions (WCS_ATT)
//         'wcsatt_scheme_changed',
//         'wcsatt_synced_products_updated',

//         // Misc / legacy
//         'updated_checkout',
//         'updated_cart_totals',
//     ].join(' '),
//     function (e, data) {
//         console.log('[WC EVENT]', e.type, data || null)
//     }
// )
